// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index.js";
import axios from "axios";
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/resetui.css'
import Qs from "qs";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'babel-polyfill'
import PinchZoom from 'vue-pinch-zoom';
import JSONbig from "json-bigint"
import {description} from "../package.json"
import en from "./lang/en.js";
import zh from "./lang/zh.js";
import { off } from 'node-notifier';
Vue.component('pinch-zoom', PinchZoom);

Vue.use(Vant);
Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false;
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
axios.defaults.transformResponse = [(data) => {
  if (typeof data === 'string') {
    try {
      data = JSONbig.parse(data);
    } catch (e) { /* Ignore */ } // Added this Ignore as it's the same in the Axios
  }
  return data;
}];
console.log("build :",description);
// const host = process.env.NODE_ENV === "development" ? "http://api.stock.com/" : "https://pc_apiserver5618.hk9999.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境

// add public key encryption code when no key in local storage
let encriptPublicKey = localStorage.getItem('encript_public_key');

if (!encriptPublicKey){
  localStorage.setItem('encript_public_key', process.env.PUBLIC_ENCRYPTION_KEY);
}

let lineURL = localStorage.getItem('lineUrl');

if (!lineURL) {
  localStorage.setItem('lineUrl', process.env.API_ROOT);
  const instance = axios.create({
    baseURL: process.env.API_ROOT,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$http = instance;

} else {
  const instance = axios.create({
    baseURL: localStorage.getItem('lineUrl'), //process.env.API_ROOT
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$http = instance;
}

/**
 * wonder chat system start
 */

const wonderChatInstace = axios.create({
  baseURL: process.env.WONDER_CHAT_ROOT,
  timeout: 10000,
  withCredentials: true
});
Vue.prototype.$wonderChat = wonderChatInstace;

//end wonder chat system
//Vue.prototype.$http = instance;

Vue.prototype.$chatApiURL = process.env.WONDER_CHAT_ROOT;//"https://chat.hk99555.com/";

let Line_1 = process.env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = process.env.Line_2;//"https://server3299.hk99111.com/";



Vue.prototype.$URLs = [{ "id": 1, "name": 'app.members.line1', "url": process.env.API_ROOT }, { "id": 2, "name": 'app.members.line2', "url": Line_1 }, { "id": 3, "name": 'app.members.line3', "url": Line_2 }];

//force logout and goto login
Vue.prototype.$logout = function (msg) {
  this.$toast.fail(msg);
  setTimeout(() => {
    this.$store.commit("changeLoginType", false);
    sessionStorage.setItem("token", "");
    localStorage.clear();
    this.$router.push("/login");
    window.location.reload();
  }, 2000);
};

// Common loader
Vue.prototype.$NoNetworkErrorMsg = "网络连接失败,稍后再试";
Vue.prototype.$ShowCommonLoading = function () {
  return this.$toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true,
    overlay: true,
    message: this.$t("app.common.loading"),
  });
};
// const host = process.env.NODE_ENV === "development" ? "/" : "https://server.hk9999z.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境
// const instance = axios.create({
//   baseURL: host,
//   timeout: 10000,
//   withCredentials: true
// });
// Vue.prototype.$http = instance;
// 添
/* eslint-disable no-new */

Vue.prototype.$LoadFromDomain = process.env.LOAD_FROM_DOMAIN;

var messages = { en: en, zh: zh };
var i18nState = Vue.observable({
  locale: localStorage.getItem("locale") || "en",
  languageLists:{}
});
if (!localStorage.getItem("locale")) {
  var nav = (navigator.language || navigator.userLanguage || "").toLowerCase();
  if (nav.indexOf("zh") === 0) i18nState.locale = "zh";
  try { localStorage.setItem("locale", i18nState.locale); } catch (e) {}
}

Vue.prototype.$http.interceptors.request.use(
  (config) => {
    // get language from localStorage (or use your i18n getter)
    const lang = localStorage.getItem("locale") || "en";

    // set header for every request
    config.headers['Accept-Language'] = lang;

    return config;
  },
  (error) => Promise.reject(error)
);

Vue.prototype.$loadLangAsync = function () {
  return Vue.prototype.$http({
     url: "/",
    method: "post",
    data: {
            nozzle: "i118_language",
            device:"app"
          }
  }).then(function (res) {
    if(res.data.code==1){
       i18nState.languageLists = res.data.data

    }
    
    return true;
  }).catch(function (e) {
    return false;
  });
}
Vue.prototype.$t = function (key) {
var pack = i18nState.languageLists|| {};
  if (Object.prototype.hasOwnProperty.call(pack, key)) return pack[key];
  if (messages.en && Object.prototype.hasOwnProperty.call(messages.en, key)) return messages.en[key];
  return key;
};

Vue.prototype.$setLocale = function (locale) {
  if (messages[locale]) {
    i18nState.locale = locale;                // reactive update
    try { localStorage.setItem("locale", locale); } catch (e) {}
    this.$loadLangAsync(locale);
  }
};

Vue.prototype.$getLocale = function () { return i18nState.locale; };
Vue.prototype.$loadLangAsync()
function getDeviceTime(utcTime) {
  const date = new Date(utcTime); 
  const offsetMinutes = date.getTimezoneOffset();
 const localDate= new Date(date.getTime() - offsetMinutes * 60 * 1000);
  return localDate.toLocaleString('sv-SE', { hour12: false }).replace('T', ' ').replace(/-/g, '.');

}
Vue.prototype.$getDeviceTime = getDeviceTime;

function getDeviceDate(utcDate) {
   const date = new Date(utcDate); 
  const offsetMinutes = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offsetMinutes * 60 * 1000);
  const Y = localDate.getFullYear();
  const M = String(localDate.getMonth() + 1).padStart(2, '0');
  const D = String(localDate.getDate()).padStart(2, '0');

  return `${Y}.${M}.${D}`;

}
Vue.prototype.$getDeviceDate = getDeviceDate;


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created() {
    // re-render when language changes
    this.$on("locale-changed", () => this.$forceUpdate());
  }
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// ./src/main.js